import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import classes from "../homePageNew.module.css";
import { cancelReport } from "../api/homePageApi";
import { RetryIcon, CategoryIcon } from "./icons";
import ReportHistoryTable from "./ReportHistoryTable";

/**
 * "N more reports" for Monitoring — same shell (title/banner/table/close)
 * as ReportsModal.js's own modal, and reuses that same ReportHistoryTable
 * (view/open/download/delete), but fetches via
 * the rows MonitoringModule already fetched — every brand's reports for
 * this user, not one transaction.
 */
export default function MonitoringReportsModal({ open, onClose, rows, loading, onRefresh, onDeleted, onViewReport }) {
  if (!open) return null;

  const handleView = (row) => {
    onViewReport({ jobId: row.jobId, category: row.category });
    onClose();
  };

  const handleDelete = async (row) => {
    if (!window.confirm("Delete this report? This can't be undone.")) return;
    try {
      await cancelReport(row.jobId);
      onDeleted(row.jobId);
    } catch {
      toast.error("Couldn't delete this report. Please try again.");
    }
  };

  return (
    <>
      <div className={classes.reportsModalOverlay} onClick={onClose} />
      <div className={classes.reportsModal}>
        <div className={classes.rpHead}>
          <div>
            <div className={classes.rpTitle}>Reporting - Monitoring</div>
            <div className={classes.rpSub}>Every monitoring report generated across all brands</div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <button className={classes.modalClose} onClick={onRefresh} title="Refresh">
              <RetryIcon size={15} />
            </button>
            <button className={classes.modalClose} onClick={onClose}>
              ✕
            </button>
          </div>
        </div>
        <div className={classes.reportsModalBanner}>
          <CategoryIcon size={15} />
          Use the table below to view, open, or download previous report versions.
        </div>
        <div className={classes.reportsModalBody}>
          {loading ? (
            <div className={classes.reportsModalLoading}>
              <CircularProgress size={24} />
            </div>
          ) : rows.length === 0 ? (
            <div className={classes.mdEmptyList}>No reports found.</div>
          ) : (
            <ReportHistoryTable rows={rows} onView={handleView} onDelete={handleDelete} />
          )}
        </div>
      </div>
    </>
  );
}
